import React from 'react';
import Skeleton from 'react-loading-skeleton';
import 'react-loading-skeleton/dist/skeleton.css';
import {
  Container,
  Header,
  ActivityRow,
  RowLeft,
  TextLines,
  RowRight
} from './ShimmerActivityList.styles';
import { ShimmerActivityListProps } from './ShimmerActivityList.types';
import { skeletonProps } from '../Shimmer.types';

const ShimmerActivityRow = () => (
  <ActivityRow>
    <RowLeft>
      <Skeleton circle width={54} height={54} {...skeletonProps} />
      <TextLines>
        <Skeleton width={140} height={16} {...skeletonProps} />
        <Skeleton width={100} height={13} {...skeletonProps} />
        <Skeleton width={80} height={12} {...skeletonProps} />
      </TextLines>
    </RowLeft>
    <RowRight>
      <Skeleton width={120} height={16} {...skeletonProps} />
      <Skeleton width={80} height={13} {...skeletonProps} />
      <Skeleton width={90} height={20} borderRadius={10} {...skeletonProps} />
    </RowRight>
  </ActivityRow>
);

export const ShimmerActivityList = ({ count = 3, width, height }: ShimmerActivityListProps) => {
  return (
    <Container $width={width} $height={height}>
      <Header>
        <Skeleton width={130} height={20} {...skeletonProps} />
        <Skeleton width={24} height={24} {...skeletonProps} />
      </Header>
      {Array.from({ length: count }).map((_, i) => (
        <ShimmerActivityRow key={i} />
      ))}
    </Container>
  );
};
